import styled from 'styled-components'

export const Container = styled.div`
  margin-top: var(--space-100);

  font-size: var(--font-size-300);
  color: var(--text-secondary);
  line-height: var(--font-line-height-300);
`
